import { Dropdown, PrimaryButton } from "@fluentui/react";
import React, { useContext }  from "react";
import DeeptekLogo from "../../../components/SVGComponents/Logo/DeeptekLogo";
import { useTranslation } from "react-i18next";
import { SHARED_VIEWER } from "../../../constants/Constants";
import "./ViewerPageCss.css";
import themeContext from "../../../context/theme/ThemeContext";
import RebrandingLogo from "../../../components/SVGComponents/Logo/RebrandingLogo";

const ViewerPage = (props) => {
  const { t } = useTranslation();
  const {themeName } = useContext(themeContext);

  let viewportData = {
    patientId: props.patientStudyData.patientId,
    patientName: props.patientStudyData.patientName,
    orderId: props.patientStudyData.orderId,
    patientAge: props.patientStudyData.patientAge,
    patientSex: props.patientStudyData.patientSex,
    studyDescription: props.patientStudyData.studyDescription,
    hospitalName: props.patientStudyData.hospitalName,
    modality: props.patientStudyData.modality,
  };

  const handleViewerClick = (viewerType) => {
    props.setShowSharedViewer(true);
    props.setSharedDefaultViewer(viewerType);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          opacity: 1,
          overflowY: "auto",
        }}
      >
        <div className="topbar-container w100 shared-study-topbar">
          <div className="topbar-buttons cursor-pointer">
            <RebrandingLogo fallback={<DeeptekLogo darkTheme={true} />} />
          </div>
          <div style={{
              fontSize: "20px",
              fontWeight: "600",
          }}>
            <span>Study Viewer Options</span>
          </div>
          <div></div>
        </div>
      </div>
      <div className="shared-viewer-body">
        <div style={{ marginBottom: "15px" }}>
          <label
            style={{
              fontSize: "18px",
              fontWeight: "600",
              padding: "0px 0px",
            }}
          >
            Study Details
          </label>
        </div>
        <div className="table-main">
          <table className="table-body">
            <tbody>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Study Description:</span>
                  <span className="value">
                    {viewportData?.studyDescription === undefined ||
                    viewportData?.studyDescription === null ||
                    viewportData?.studyDescription === "-"
                      ? ""
                      : viewportData?.studyDescription}
                  </span>
                </div>
              </tr>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Patient Id:</span>
                  <span className="value">{viewportData?.patientId}</span>
                </div>
              </tr>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Order Id:</span>
                  <span className="value">
                    {viewportData?.orderId === "undefined" ||
                    viewportData?.orderId === null || viewportData?.orderId === ""
                      ? "-"
                      : viewportData?.orderId}
                  </span>
                </div>
              </tr>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Patient Name:</span>
                  <span className="value">{viewportData?.patientName}</span>
                </div>
              </tr>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Age | Gender:</span>
                  <span className="value">
                    {viewportData?.patientAge?.slice(0, 1) === "0"
                      ? viewportData?.patientAge?.slice(1, 3) === "-"
                        ? "-"
                        : viewportData?.patientAge?.slice(1, 3)
                      : viewportData?.patientAge?.slice(0, 3) === "-"
                      ? "-"
                      : viewportData?.patientAge?.slice(0, 3)}{" | "}
                    {viewportData?.patientSex === undefined ||
                    viewportData?.patientSex === null ||
                    viewportData?.patientSex === "-"
                      ? "-"
                      : viewportData?.patientSex === "M"
                      ? t("viewer.overlay.male")
                      : t("viewer.overlay.female")}
                  </span>
                </div>
              </tr>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Modality:</span>
                  <span className="value">{viewportData?.modality}</span>
                </div>
              </tr>
              <tr className="table-row">
                <div className="leftKeyBlock">
                  {/* <span className="leftKey"> */}
                  <span className={`leftKey ${themeName === 'light' ? 'light-mode' : ''}`}>
                    Branch Name:</span>
                  <span className="value">{viewportData?.hospitalName}</span>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                fontSize: "18px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              Available Viewers
            </label>
          </div>
          <div className="viewer-buttons">
            <PrimaryButton
              text="Viewer 1"
              style={{
                // marginRight: "10px",
                // marginBottom: "15px",
              }}
              // onClick={() => handleViewerClick(SHARED_VIEWER.BASIC)}
              href={props.basicStudyURL}
              target="_blank"
            />
            <p style={{ 
                marginBottom: "15px", 
                fontSize: "11px", 
                // color: "rgba(255, 255, 255, 0.58)" , 
                color: themeName === "light" ? "#3b3b3b" : "rgba(255, 255, 255, 0.58)", 
                fontWeight: "600", 
                letterSpacing: "0.75px", 
                wordWrap: "break-word"
              }}>
            * Preferred viewer for XRAY
            </p>
            <PrimaryButton
              text="Viewer 2"
              style={{
                // marginRight: "10px",
                //marginBottom: "10px",
              }}
              // onClick={() => handleViewerClick(SHARED_VIEWER.ADVANCE)}
              href={props.advanceStudyURL}
              target="_blank"
            />
            <p style={{ 
                fontSize: "11px", 
                // color: "rgba(255, 255, 255, 0.58)" , 
                color: themeName === "light" ? "#3b3b3b" : "rgba(255, 255, 255, 0.58)", 
                fontWeight: "600", 
                letterSpacing: "0.75px", 
                wordWrap: "break-word"
              }}>
            * Preferred viewer for CT/MRI/PET
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewerPage;
